import { Autocomplete, FormControl, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { CommonMainWrap, CommonSubBox, ListDetailTemplate, OneList } from "../../../styles/common";
import { useEffect, useState } from "react";
import { useGetSetupCodeList, useGetSetupList } from "../../../interfaces/setup";

const Setups = ({}) => {

    const [userList, setUserList] = useState([]);

    const [pointList, setPointList] = useState([]);
    const [unoList, setUnoList] = useState([]);

    const [filterList, setFilterList] = useState([]);

    const [inst_cd, setInst_cd] = useState([]);
    const [setup_st, setSetup_st] = useState([]);
    const [setup_ret, setSetup_ret] = useState([]);
    const [setup_err_cd, setSetup_err_cd] = useState([]);

    const {data} = useGetSetupList();
    const {data:codeList} = useGetSetupCodeList();

    useEffect(()=>{
        if(data){
            let temp = data.filter((item,index,self)=> index === self.findIndex((t) => (t.tid === item.tid && t.point_nm === item.point_nm)));
            setPointList(temp);
            const inst_uno = data.filter((item,index,self)=> index === self.findIndex((t) => (t.inst_uno === item.inst_uno))).map((item)=>({uno:item.inst_uno,unm:item.inst_unm}));
            const remv_uno = data.filter((item,index,self)=> index === self.findIndex((t) => (t.remv_uno === item.remv_uno))).map((item)=>({uno:item.remv_uno,unm:item.remv_unm}));;
            temp = [...inst_uno, ...remv_uno].filter((item,index,self)=> index === self.findIndex((t)=>t.uno && (t.uno === item.uno)));
            setUnoList(temp);
        }
    },[data])

    useEffect(()=>{
        codeList && console.log('codeList',codeList)
    },[codeList])


    return (
        <CommonMainWrap style={{display:'flex',justifyContent:'flex-start',alignItems:'center',flexDirection:'column'}}>
            <CommonSubBox style={{width:'100%', justifyContent:'space-between'}}>
                <div style={{display:'flex',alignItems:'start',gap:'8px'}}>
                    <TextField
                            id='pnm'
                            label='지점명'
                            size='small'
                            InputLabelProps={{shrink:true}}
                            // value={searchAlias}
                            // onChange={(e)=>setSearchAlias(e.target.value)}
                        />
                    <Autocomplete
                        id="user"
                        size='small'
                        options={userList}
                        style={{width:'10rem'}}
                        // value={(target && target.sur_tp_nm) && target.sur_tp_nm}
                        renderInput={(params) => <TextField {...params} label='담당자'InputLabelProps={{shrink:true}} />}
                        // onChange={(e,v)=>(v!==null)&&handleAutoValueChange('sur_tp',v.code,'sur_tp_nm',v.value)}
                    />
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="is_ing-label"
                            defaultValue={''}
                            name="listType"
                            // onChange={(e)=>setSearchRegId(e.target.value)}
                        >
                            <FormControlLabel value={''} control={<Radio />} label={`지점별`} />
                            <FormControlLabel value={1} control={<Radio />} label={`담당자별`} />
                        </RadioGroup>
                    </FormControl>
                </div>
            </CommonSubBox>
            <ListDetailTemplate style={{minHeight:'100%',gridTemplateColumns:'20rem auto'}}>
                <div className="list">
                    <OneList>
                        <ul className="descArea">
                        {pointList && pointList.map((item,index)=>
                            <li key={index} className={'descLiItem'}>
                                <span/>
                                <span>{item.snm}/{item.sno}/{item.point_nm}</span>
                            </li>
                        )}
                        </ul>
                    </OneList>
                </div>
                <div className="detail">
                    {pointList && pointList.map((item,index)=>{
                        return (
                            <div key={index}>
                                {JSON.stringify(item)}
                            </div>
                        )
                    })}
                </div>
            </ListDetailTemplate>
        </CommonMainWrap>
    )

}

export default Setups;